/**
 * @generated SignedSource<<0a85f8d8891fe155ecd007809dbb0605>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoAssigneesPopover_EmployeeConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"TodoAssigneesPopover_EmployeeItem">;
    };
  }>;
  readonly " $fragmentType": "TodoAssigneesPopover_EmployeeConnection";
};
export type TodoAssigneesPopover_EmployeeConnection$key = {
  readonly " $data"?: TodoAssigneesPopover_EmployeeConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoAssigneesPopover_EmployeeConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoAssigneesPopover_EmployeeConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeConnectionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TodoAssigneesPopover_EmployeeItem"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EmployeeConnection",
  "abstractKey": null
};

(node as any).hash = "537629e79aed8ed7685ca9873b95d987";

export default node;
